export default __webpack_public_path__ + "static/synaxon-1c5fa321244b03ccd0a725ef133b03a2.png";